import FileDetail from "../controllers/Repository/FileDetail";
import { StackLayout } from "../layouts";
import { rows, inputs, Filters, ScrollableList, List } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import theme from "colbi_web_ui/lib/style/_theme.json";
import HeaderListButtons from "../actions/HeaderListButtons/HeaderListButtons";
import UserActions from "../actions/UserActions/UserActions";
import SeriesButton from "../components/SeriesButton/SeriesButton";
import { toast } from "react-toastify";
import Repository from "../controllers/App/Repository";

const queries = (args = {}) => {
    return [
        {
            resource: args.section,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear || "",
                fileType: args.fileType || "",
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                page: ["folders", "merge_collisions", "submission_saft", "generation"].includes(
                    args.section,
                )
                    ? parseInt(args.page, 10) || 0
                    : null,
            },
            body: `__typename, items{...${args.section}}, total, hasMore,filters(projectId:$projectId, fiscalYear:$fiscalYear){ prop, name, type, list, disableOperators, mandatory}`,
            downloadable: true,
            forceRefresh: true,
        },
        {
            resource: "show_terms_and_conditions",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        {
            resource: "project_modules",
            args: {
                projectId: args.projectId,
            },
            body: "modules",
        },
        {
            resource: "csv_delimiter",
            args: {
                projectId: args.projectId,
            },
            forceRefresh: true,
        },
        args.id
            ? {
                  resource: `${args.section}_detail`,
                  args: {
                      projectId: args.projectId,
                      fiscalYear: args.fiscalYear,
                      id: args.id,
                      locale: args.locale || "",
                  },
                  body: `...${args.section}_detail`,
              }
            : {},
    ].filter((r) => !!r.resource);
};

const repository = (
    path,
    navigation,
    scrollableList = false,
    showGenerationButton = false,
    showGenerationReloadButton = false,
) => ({
    path,
    navigation,
    component: Repository,
    exact: false,
    queries,
    components: [
        {
            component: inputs.FileUploader,
            props: {
                lastReadTime: "status(0).lastReadTime",
                showTermsUpload: "query(1)",
                toast: toast,
                delimiter: "query(3)",
            },
        },
        {
            component: SeriesButton,
            props: {
                projectModules: "query(2)",
            },
        },
        {
            component: Filters,
            props: {
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                stickyTop: parseInt(theme.layout.$headerHeight, 10),
                anchor: "results",
            },
        },
        {
            component: scrollableList ? ScrollableList : List,
            modifiers: ["--root-margin-top-small", "--row-style-alternate"],
            props: {
                id: "results",
                card: rows.EntityCard,
                headerListComponent: [
                    {
                        component: UserActions,
                        props: {
                            total: "query(0).metadata.total",
                        },
                    },
                    {
                        component: HeaderListButtons,
                        props: {
                            showGenerationButton: showGenerationButton,
                            showRefreshButton: showGenerationReloadButton,
                            endPointToRequest: "GenericRequest",
                        },
                    },
                ],
                checkbox: true,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                sort: "param(sort)",
                wrapper: "wrapper",
            },
        },
    ],
    routes: [
        {
            path: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear/:importId/repository/:section/:fileType/:id",
            exact: true,
            queries,
            component: StackLayout,
            components: [
                {
                    component: FileDetail,
                    props: {
                        modules: "query(2)",
                        data: "query(4)",
                    },
                },
            ],
        },
    ],
});

export default repository;
